import { action } from 'satcheljs';

export default action('SHOW_QUICK_OPTIONS', () => ({}));
